import { useQuery, useMutation, useQueryClient } from 'react-query';
import { fetchCities, addCity, updateCity, deleteCity, getAllRegions, } from '@/features/city/services/cityService';
const useCities = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    // Query for cities: using the unified fetchCities function.
    const { data: cityData, error, isLoading, refetch, } = useQuery(['cities', { page, filters, all, limit }], () => fetchCities(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    // Query for regions.
    const { data: regionData, error: regionError, isLoading: regionsLoading, } = useQuery('regions', getAllRegions, { staleTime: 60000 });
    // Mutation for adding a city.
    const addCityMutation = useMutation((city) => addCity(city), {
        onSuccess: () => {
            queryClient.invalidateQueries(['cities']);
        },
    });
    // Mutation for updating a city.
    const updateCityMutation = useMutation(({ id, city }) => updateCity(id, city), {
        onSuccess: () => {
            queryClient.invalidateQueries(['cities']);
        },
    });
    // Mutation for deleting a city.
    const deleteCityMutation = useMutation((id) => deleteCity(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(['cities']);
        },
    });
    return {
        cities: cityData?.cities || [],
        meta: cityData?.meta || null,
        regions: regionData?.regions || [],
        loading: isLoading || regionsLoading,
        error: error ? error.message : regionError ? regionError.message : null,
        handleAddCity: addCityMutation.mutateAsync,
        handleUpdateCity: updateCityMutation.mutateAsync,
        handleDeleteCity: deleteCityMutation.mutateAsync,
        refetchCities: refetch,
    };
};
export default useCities;
